// import VConsole from 'vconsole'

import {RewardJsToggleCloseBtnShow, VideoBridgeToggleBouncesOff} from "../../api";
import {_device} from "../../common/m_base/util";

class Template {
    constructor(props) {
    }

    /**
     * 初始化
     * @return
     */
    init({JsBridgeRes}) {

        // 针对 Promise 添加调试监听
        window.addEventListener("unhandledrejection", event => {
            console.warn(`UNHANDLED PROMISE REJECTION: ${event.reason}`, {event});
        });

        // iOS 下禁用滑动反弹
        if (_device().isiOS) {
            VideoBridgeToggleBouncesOff()
        }

        // this.bindEvent()
    }

    show(res) {
        console.log('----------webviewshow triggered.')
        // this.initCloseButton(res)
        console.log('----------initCloseButton done.')
        // this.showVideo(res)
        // this.playVideo(res)
    }

    /**
     * 绑定事件
     * @return
     */
    bindEvent() {
        this.bindPageEvent()
        this.bindNativeEvent()
    }

    bindPageEvent() {
        console.log('接口方法，未实现')
    }

    bindNativeEvent() {
        console.log('接口方法，未实现')
    }

    /**
     * 安装
     * @param any
     */
    install() {
        console.log('接口方法，未实现')
    }

    async fetchDataSource(params) {
        return await api.VideoBridgeInit(params)
    }

    append(component) {

    }

    appendTo(component) {

    }

    enableDebugMode() {
        window.vConsole = new VConsole()
    }

    showVideo(res) {
        console.log('----------showVideo done.')
    }

    playVideo(res) {
        console.log('----------playVideo done.')
    }

    initCloseButton(res) {
        RewardJsToggleCloseBtnShow()
    }
}

export default Template